import url from './url';
const modeUrlObj = {
    //本地开发 运行：npm run serve:local   打包：npm run build:local
    'local':{
        apiUrl:"http://localhost:5000",
        appBaseUrl:"http://testsixunwxd.sissyun.com/mall",
        cdnUrl:"https://testimg1.sissyun.com.cn"
    },
    // 线上242服务器开发环境 运行：npm run serve:dev   打包：npm run build:dev
    'development': {
        apiUrl: "https://storeapiv3.sissyun.com.cn",
        appBaseUrl:"https://ministore.sissyun.com.cn",
        cdnUrl:"https://testimg1.sissyun.com.cn" 
    },
    // 线上测试环境 运行：npm run serve:test   打包：npm run build:test
    'test': {
        apiUrl: "/mall",
        appBaseUrl:"/mobile",
        cdnUrl:"https://testimg1.sissyun.com.cn" 
    },
     // 线上预发布环境 运行：npm run serve:beta   打包：npm run build:beta
     'beta': {
        apiUrl: "http://127.0.0.1:21021",
        appBaseUrl:"http://127.0.0.1:7001",
        cdnUrl:"https://testimg1.sissyun.com.cn" 
    },
    // 生产环境 运行：npm run serve:pro   打包：npm run build:pro
    'production': {
        apiUrl: "/mall",
        appBaseUrl:"/mobile",
        cdnUrl:"https://img1.sissyun.com.cn" 
      
    },
     // 线上242服务器开发环境 运行：npm run serve:dev   打包：npm run build:dev
     'huidudevelopment': {
        apiUrl: "https://storeapiv3-hd.sissyun.com.cn",
        appBaseUrl:"https://ministore-hd.sissyun.com.cn",
        cdnUrl:"https://testimg1.sissyun.com.cn" 
    },
    // 线上测试环境 运行：npm run serve:test   打包：npm run build:test
    'huidutest': {
        apiUrl: "https://teststoreapiv3-hd.sissyun.com.cn",
        appBaseUrl:"https://testministore-hd.sssyun.com.cn",
        cdnUrl:"https://testimg1.sissyun.com.cn" 
    },
    // 生产环境 运行：npm run serve:pro   打包：npm run build:pro
    'huiduproduction': {
        apiUrl: "/mall",
        appBaseUrl:"/mobile",
        cdnUrl:"https://img1.sissyun.com.cn" 
      
    },
  }
const SissConsts = {
    localization: {
        defaultLocalizationSourceName: 'FengCloud',
    },
    authorization: {
        encrptedAuthTokenName: 'enc_auth_token',
    },
    appBaseUrl: modeUrlObj[process.env.VUE_APP_CURENV].appBaseUrl,
    remoteServiceBaseUrl:  modeUrlObj[process.env.VUE_APP_CURENV].apiUrl,
    cdnurl: modeUrlObj[process.env.VUE_APP_CURENV].cdnUrl,
    qqMapUrl: "https://apis.map.qq.com/ws/distance/v1/matrix/",
    qqMapKey: "LRQBZ-FKIH4-NUVUU-XZ5SW-FEIVO-6MFMG",
};
export default SissConsts;
